var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Container, } from 'reactstrap';
import { inject } from 'mobx-react';
import { T } from '../../../helpers/i18n';
import InputImage from '../../../elements/FieldImage';
import { getChangedValues } from '../../../helpers/getChangedValues';
import { prepareToSubmitForm } from '../../../helpers/prepareToSubmitForm';
// @ts-ignore
export var MarketingForm = inject('store')(function (props) {
    var store = props.store, values = props.values, stretch_id = props.stretch_id, onChange = props.onChange, onDefault = props.onDefault, onSubmit = props.onSubmit;
    var _a = useState(values || {}), formData = _a[0], setFormData = _a[1];
    var handleChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[name] = value, _a)));
        onChange(name, value, null);
    };
    var handleDeleteImage = function (name) {
        var _a;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[name] = null, _a)));
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        var toUpload = getChangedValues(props.values || {}, formData);
        if (Object.entries(toUpload).length === 0) {
            return store.UI.newWarning(T('nothingModified'));
        }
        // busco si alguno es de tipo File para crear un objeto FormData en vez de un objeto {}
        var data = prepareToSubmitForm(toUpload);
        onSubmit(data);
    };
    var setDefaults = function () {
        // console.log('setDefaults - stretch: ', stretch)
        if (!onDefault) {
            return store.UI.newWarning('onDefault no implementado');
        }
        var data = {
            owner_ids: stretch_id
        };
        onDefault();
    };
    console.log('render - formData: ', formData);
    return (React.createElement(Container, null,
        React.createElement(Button, { onClick: stretch_id ? setDefaults : undefined }, 'Set defaults'),
        onSubmit && React.createElement(Button, { onClick: handleSubmit }, 'submit'),
        React.createElement(Form, null,
            React.createElement("h4", null, T('titles')),
            React.createElement(Row, null,
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "title" }, "Title"),
                        React.createElement(Input, { type: "text", name: "title", id: "title", value: formData.title || '', onChange: handleChange }))),
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "titleOG" }, "Title OG"),
                        React.createElement(Input, { type: "text", name: "titleOG", id: "titleOG", value: formData.titleOG || '', onChange: handleChange })))),
            React.createElement("h4", null, T('descriptions')),
            React.createElement(Row, null,
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "description" }, "Description"),
                        React.createElement(Input, { type: "text", name: "description", id: "description", value: formData.description || '', onChange: handleChange }))),
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "descriptionOG" }, "Description OG"),
                        React.createElement(Input, { type: "text", name: "descriptionOG", id: "descriptionOG", value: formData.descriptionOG || '', onChange: handleChange })))),
            React.createElement("h4", null, T('urls')),
            React.createElement(Row, null,
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "urlPage" }, "Page URL"),
                        React.createElement(Input, { type: "url", name: "urlPage", id: "urlPage", value: formData.urlPage || '', onChange: handleChange }))),
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "urlPageOG" }, "Page URL OG"),
                        React.createElement(Input, { type: "url", name: "urlPageOG", id: "urlPageOG", value: formData.urlPageOG || '', onChange: handleChange })))),
            React.createElement("h4", null, T('images')),
            React.createElement(Row, null,
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(InputImage, { name: 'image', value: formData.image || '', onChange: function (name, value, column) {
                                var e = { target: {} };
                                e.target.name = 'image';
                                e.target.value = value[0];
                                handleChange(e);
                            } }))),
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(InputImage, { name: 'imageOG', value: formData.imageOG || '', onChange: function (name, value, column) {
                                var e = { target: {} };
                                e.target.name = 'imageOG';
                                e.target.value = value[0];
                                handleChange(e);
                            } })))))));
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/MarketingForm.tsx
// module id = 1529
// module chunks = 0